// --------------------------------------------------------------
// Created On: 2022-09-07
// Author: Zachary Thomas
//
// Last Modified: 2026-01-20
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./PopulateControl.module.scss";

// Message and toggle option for auto-populate for new resources.
export default function PopulateControl(props: Props): Component {
  return props.active ? (
    <div className={`alert alert-primary ${styles.body}`}>
      <div className={styles.text}>
        <span>
          {`New ${props.resourceType}s will be automatically added to this ${props.resourceType} group when ${props.associationMessage}.`}
        </span>
        <button
          data-test="populate-control-toggle"
          className={`btn btn-primary ${styles.button}`}
          disabled={props.disabled}
          onClick={() => props.onChange()}
        >
          Remove as Default
        </button>
      </div>
    </div>
  ) : (
    <div className={`alert alert-secondary ${styles.body}`}>
      <div className={styles.text}>
        <span>
          {`Set as default to automatically add new ${props.resourceType}s to this ${props.resourceType} group when ${props.associationMessage}.`}
        </span>
        <button
          data-test="populate-control-toggle"
          className={`btn btn-secondary ${styles.button}`}
          disabled={props.disabled}
          onClick={() => props.onChange()}
        >
          Set as Default
        </button>
      </div>
    </div>
  );
}

interface Props {
  resourceType: string;
  associationMessage: string;
  active: boolean;
  disabled: boolean;
  onChange: () => void;
}
